import * as React from "react"
import {
	formatDeleveragingYears
} from "../../../../domain/sfp/cash-flow-domain"

export default class DeleveragingYearsCell
extends React.Component<Props> {
	render() {
		const formattedValue = formatDeleveragingYears(this.props.value)
		return <span>{formattedValue}</span>
	}
}

export interface Props {
	value: any
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/delevaraging-years-cell.tsx